'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import useScrollPosition from '@/lib/utils/useScrollPosition';
import { mergePropsClassName } from '@liquorice/utils';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import useResizeObserver from 'use-resize-observer';
import HideOnScroll from '../HideOnScroll';
import Box, { BoxProps } from '../ui/Box';
import Container from '../ui/Container';
import * as styles from './NavBar.css';
import { useNavBar } from './useNavBar';
import { useNavbarActions } from './useNavbarState';

export default function NavInner({ children, ...props }: BoxProps) {
  const { setHeight, fallbackHeight } = useNavbarActions();
  const pos = useScrollPosition();
  const { page } = useNavBar();

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, page);
  const eventUri = base?.sectionHandle === 'event';

  const { ref, height = fallbackHeight } = useResizeObserver<HTMLDivElement>({
    onResize: ({ height }) => {
      setHeight(height);
    },
  });

  return (
    <HideOnScroll>
      <Box
        ref={ref}
        {...mergePropsClassName(props, styles.wrapper)}
        style={assignInlineVars({
          [styles.navbarHeight]: `${height ?? fallbackHeight}px`,
        })}>
        <Box
          className={styles.inner({
            useCreamColorScheme: pos > 10 || !eventUri,
          })}>
          <Container>{children}</Container>
        </Box>
      </Box>
    </HideOnScroll>
  );
}
